import script from "./BubbleFish.vue?vue&type=script&setup=true&lang=js"
export * from "./BubbleFish.vue?vue&type=script&setup=true&lang=js"

import "./BubbleFish.vue?vue&type=style&index=0&id=1f058800&lang=css"

const __exports__ = script;

export default __exports__